import React, {useContext, useState} from 'react';
import Uploader from "../ui/outlet-views/Upload"

function Upload(props) {
    return <Uploader {...props}/>
}

export default Upload;